export default __webpack_public_path__ + "static/media/call-muted.240072b9.svg";